import { initializeApp } from 'firebase/app';
import {
  getFirestore,
  collection,
  doc,
  setDoc,
  addDoc,
  getDoc,
  getDocs,
  deleteDoc,
} from 'firebase/firestore';
import {
  getStorage,
  ref,
  getDownloadURL,
  uploadBytes,
} from 'firebase/storage';
import { getAuth, signInWithEmailAndPassword, signOut, onAuthStateChanged } from "firebase/auth";
import { notify } from "@kyvg/vue3-notification";
import Router from '@/Router';
import Cookies from 'js-cookie';

const firebaseConfig = {
  apiKey: 'AIzaSyDihYZS1qWgRPEnINGjpgKe2ib2v8jXcWM',
  authDomain: 'galleriamaria-6b2fd.firebaseapp.com',
  projectId: 'galleriamaria-6b2fd',
  storageBucket: 'galleriamaria-6b2fd.appspot.com',
  messagingSenderId: '640898922120',
  appId: '1:640898922120:web:a654b13d663b102c41913d',
  measurementId: 'G-HQBTENGYLL',
};

const APP = initializeApp(firebaseConfig);
const DB = getFirestore(APP);
const STORAGE = getStorage();
const AUTH = getAuth();
// ====== API ENDPOINTS ========

// User auth
onAuthStateChanged(AUTH, (user) => {
  if (user) {
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    Cookies.set("user", user.uid);
  } else {
    Cookies.set("user", "");
  }
});

export const isLoggedIn = async() => {
  const userId = Cookies.get("user");
  if (userId) {
    const token = AUTH
      .verifyIdToken(userId)
      .then((decodedToken) => {
        const uid = decodedToken.uid;
      })
      .catch((error) => {
        throw error;
      });
    return token || false;
  }
  return false;
}

export const login = (email, password) => {
  signInWithEmailAndPassword(AUTH, email, password)
    .then((userCredential) => {
      notify({ text: "Du är nu inloggad", type: "success" });
      Router.push("/");
    })
    .catch((error) => {
      notify({ text: "Felaktiga uppgifter", type: "error" });
      throw error;
    });
}

export const logout = () => {
  console.log("We got to logout");
  signOut(AUTH)
    .then(() => {
      notify({ text: "Du loggades ut", type: "success" });
      return true;
    })
    .catch((error) => {
      notify({ text: "Utloggning misslyckades", type: "error" });
      throw error;
    });
}
// Textfield
export const getTextFields = async (type) => {
  const textFieldCollection = collection(DB, type);
  const result = await getDocs(textFieldCollection);
  const textFields = result.docs.map((document) => ({
    id: document.id,
    ...document.data(),
  })).sort((a, b) => (a.timestamp > b.timestamp ? 1 : -1));
  return textFields;
};
export const updateTextField = (type, id, textField) => {
  const textFieldCollection = collection(DB, type);
  return setDoc(doc(textFieldCollection, id), textField);
};
export const addTextField = (type, textField) => {
  const textFieldCollection = collection(DB, type);
  return addDoc(textFieldCollection, textField);
};
export const deleteTextField = (type, id) => {
  const textFieldCollection = collection(DB, type);
  return deleteDoc(doc(textFieldCollection, id));
};

// Text
const textCollection = collection(DB, 'text');
export const getText = async (id) => (await getDoc(doc(textCollection, id))).data().text;

export const updateText = (id, text) => setDoc(doc(textCollection, id), {
  text,
});
export const addText = (text) => addDoc(textCollection, text);

export const deleteText = async (id) => deleteDoc(doc(textCollection, id));

// Images
export const getFile = async (id) => getDownloadURL(ref(STORAGE, id));

export const uploadFile = async (file) => {
  await uploadBytes(ref(STORAGE, `images/${file.name}`), file);
};